import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import CreateBooking from './CreateBooking';
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import { closeScheduledBookingModal } from '../../../actions/siteadmin/modalActions';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.addNewBooking);

    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account && store.getState().account.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;
    store.dispatch(closeScheduledBookingModal());

    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/manual-bookings', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <CreateBooking />
            </AdminLayout>
        )
    }
}

export default action;